import React, { useContext } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "@asosteam/asos-web-react-i18n";
import StoreDataContext from "src/app/context/store-data";
import InfoMessage from "src/app/components/InfoMessage";

const URLS = {
  AU: "https://www.asos.com/au/customer-care/technical/im-having-trouble-accessing-your-website-can-you-help/",
  COM: "https://www.asos.com/customer-care/technical/im-having-trouble-accessing-your-website-what-should-i-do/",
  DE: "https://www.asos.com/de/kundenservice/technisch/ich-habe-probleme-die-asos-website-aufzurufen/",
  DK: "https://www.asos.com/dk/kundeservice/teknisk/hvad-gor-jeg-hvis-jeg-har-problemer-med-at-komme-ind-paa-jeres-webside/",
  ES: "https://www.asos.com/es/atencion-al-cliente/soporte-tecnico/tengo-problemas-al-acceder-o-comprar-en-vuestra-web/",
  FR: "https://www.asos.com/fr/service-client/questions-techniques/que-faire-si-je-narrive-pas-a-me-connecter-a-mon-compte-/",
  IT: "https://www.asos.com/it/assistenza-clienti/assistenza-tecnica/non-riesco-ad-accedere-al-sito-o-a-effettuare-acquisti/",
  NL: "https://www.asos.com/nl/klantenservice/technisch/ik-ondervind-problemen-met-jullie-website-wat-kan-ik-doen/",
  PL: "https://www.asos.com/pl/obsluga-klienta/kwestie-techniczne/mam-problem-z-dostepem-do-waszej-strony-co-zrobic-w-tej-sytuacji/",
  RU: "https://www.asos.com/ru/центр-поддержки/технические-вопросы/как-решить-проблемы-с-загрузкой-и-открытием-вашего-вебсайта/",
  SE: "https://www.asos.com/se/kundservice/tekniskt/vad-ska-jag-gora-om-jag-har-problem-att-komma-in-pa-er-webbsida/",
  US: "https://www.asos.com/us/customer-care/technical/im-having-trouble-logging-into-my-account-what-should-i-do/",
};

function ChatBotErrorMessage({ formatTranslation }) {
  const { storeCode } = useContext(StoreDataContext);
  const url = URLS[storeCode] || URLS["COM"];

  return (
    <InfoMessage>
      <p>{formatTranslation("cchp_chat_bot_nuance_error_title")}</p>
      <ul>
        <li>{formatTranslation("cchp_chat_bot_nuance_error_first_line")}</li>
        <li>{formatTranslation("cchp_chat_bot_nuance_error_second_line")}</li>
        <li>{formatTranslation("cchp_chat_bot_nuance_error_third_line")}</li>
        <li>
          <a href={url}>
            {formatTranslation("cchp_chat_bot_nuance_error_fourth_line")}
          </a>
        </li>
      </ul>
    </InfoMessage>
  );
}

ChatBotErrorMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(ChatBotErrorMessage);
